<template>
  <div class="w-100 py-3 shadow-custom" style="z-index:10;">
    <slot />
  </div>
</template>

<script>
export default {

};
</script>
